import { useCallback, useMemo, useState } from 'react';
import { ProductsModelCompareContext, ProductsModelCompareType } from './ProductsModelCompareContext';

const ProductsModelCompareProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [selectedModels, setSelectedModels] = useState<string[]>([]);

  const isModelSelected = useCallback((itemId: string) => selectedModels.includes(itemId), [selectedModels]);

  const selectModel = useCallback((itemId: string) => {
    setSelectedModels((prev) => (prev.includes(itemId) ? prev.filter((sm) => sm !== itemId) : [...prev, itemId]));
  }, []);

  const clearSelectedModels = useCallback(() => {
    setSelectedModels([]);
  }, []);

  const contextValue: ProductsModelCompareType = useMemo(
    () => ({
      selectedModels,
      selectModel,
      clearSelectedModels,
      isModelSelected,
    }),
    [selectedModels, selectModel, clearSelectedModels, isModelSelected],
  );

  return <ProductsModelCompareContext.Provider value={contextValue}>{children}</ProductsModelCompareContext.Provider>;
};

export default ProductsModelCompareProvider;
